import React from 'react';
import { isDev } from '../../lib/config';
import { OneClickStateBadge } from './OneClickStateBadge';
import { DeveloperSettingsPanel } from './Panels/DeveloperSettingsPanel';
import { ManageSessionsPanel } from './Panels/ManageSessionsPanel';
import { SettingsOneClickPanel } from './Panels/SettingsOneClickPanel';
import { SettingsRenewPanel } from './Panels/SettingsRenewPanel';
import { SettingsRevokePanel } from './Panels/SettingsRevokePanel';
import { SettingsTradePanel } from './Panels/SettingsTradePanel';

export type SettingsPanel = {
  id: string;
  component: { component: React.FC; panelClassName?: string };
  titleLabel: React.ReactNode | React.FC;
  buttonLabel?: React.ReactNode | React.FC;
  showInMenu?: boolean;
};

export const getSettingsPanels = (subaccountPickerEnabled: boolean) =>
  [
    {
      id: 'one-click',
      buttonLabel: () => (
        <div className="flex w-full items-center justify-between text-xs font-medium text-contentSecondary">
          <span>One-Click Trading</span>
          <div className="flex items-center">
            <OneClickStateBadge />
          </div>
        </div>
      ),
      titleLabel: 'One-Click Trading',
      component: { component: SettingsOneClickPanel },
      showInMenu: true,
    },
    {
      id: 'trade',
      titleLabel: 'Trade Preferences',
      component: { component: SettingsTradePanel },
      showInMenu: true,
    },
    {
      id: 'renew',
      titleLabel: 'Renew One-Click',
      component: { component: SettingsRenewPanel },
    },
    {
      id: 'disable-one-click',
      titleLabel: 'Disable One-Click',
      component: { component: SettingsRevokePanel },
    },
    {
      id: 'revoke',
      titleLabel: 'Revoke Trading Session',
      component: { component: SettingsRevokePanel },
    },
    {
      id: 'manage-sessions',
      titleLabel: 'Manage Trading Sessions',
      component: {
        component: ManageSessionsPanel,
        panelClassName: 'max-w-[800px] duration-700',
      },
    },
    ...(isDev || subaccountPickerEnabled
      ? [
          {
            id: 'dev-settings',
            titleLabel: 'Dev Settings',
            component: { component: DeveloperSettingsPanel },
            showInMenu: true,
          },
        ]
      : []),
  ] as const satisfies SettingsPanel[];

export type SettingsPanelId = ReturnType<typeof getSettingsPanels>[number]['id'];
